import EAIcon from "components/common/EAIcon";
import EAAlert from "components/EAAlert";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { ERROR } from "services/common/Constants";
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';

const SecurityRatingError = ({ error, goBack = () => { } }) => {
  const { classes } = useStyles();

  const { t } = useTranslation();

  const [title, setTitle] = useState();
  const [subTitle, setSubTitle] = useState();

  useEffect(() => {
    if (error?.includes("asset")) {
      setTitle("securityRating.errors.ASSETS");
      setSubTitle("securityRating.messages.newDomain")
    } else {
      setTitle(error);
      setSubTitle(null);
    }
  }, [error])

  return (
    <div className={classes.errorWrapper}>
      <div className={classes.goBack} onClick={goBack}>
        <EAIcon icon="/arrow/arrow-back-navigation" />
        {t("back")}
      </div>
      <EAAlert severity={ERROR} closable={false}>
        {title && (
          <div className={classes.errorTitle}>
            {t(title, { defaultValue: t('securityRating.errors.UNKNOWN') })}
          </div>
        )}
        {subTitle && (
          <div className={classes.errorSubTitle}>
            {t(subTitle)}
          </div>
        )}
      </EAAlert>
    </div>
  )
};

export default SecurityRatingError;